import { Logger, engineComponent } from "neo-common";
import { Song } from "./Song";
import { ComponentTypes } from "../ComponentTypes";
import { SoundManager } from "../Managers/SoundManager";
@engineComponent(ComponentTypes.PlayList)
export class PlayList {
    static Songs: { [id: string]: Song } = {};

    static addToPlayList(song: Song): void {
        PlayList.Songs[song.id] = song;
    }

    create(node: Element): void {
        SoundManager.parseElements(node, node.nodeName);
    }

    static isPlaying(song: string): boolean {
        if (PlayList.Songs[song] != null) {
            return PlayList.Songs[song].isPlaying();
        }
    }

    static play(song: string, fadeIn: number = 0, reset: boolean = true): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].play(false, fadeIn, reset);
            if (DEBUG) {
                PlayList.log("play song " + song);
            }
        }
    }

    static loop(song: string, fadeIn: number = 0, reset: boolean = false): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].play(true, fadeIn, reset);
            if (DEBUG) {
                PlayList.log("loop song " + song);
            }
        }
    }

    static stop(song: string, fadeOut: number = 0): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].stop(fadeOut);
            if (DEBUG) {
                PlayList.log("stop song " + song);
            }
        }
    }

    static stopAll(fadeOut: number = 0): void {
        if (PlayList.Songs != null) {
            for (let song in PlayList.Songs) {
                PlayList.Songs[song].stop(fadeOut);
            }
            if (DEBUG) {
                PlayList.log("stopAll songs");
            }
        }
    }

    static stopAllInGroup(group: string, toggle: boolean = false): void {
        if (PlayList.Songs != null) {
            for (let song in PlayList.Songs) {
                PlayList.Songs[song].toggleGroup(group, toggle);
            }
        }
    }

    static log(s: string): void {
        if (DEBUG) {
            const compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }

    //******************************************************************************************************************
    //  IT'S SPECIAL...
    //******************************************************************************************************************

    static setVolume(song: string, volume: number): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].setVolume(volume);
        }
    }

    static resetVolume(song: string, fadeDuration?: number): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].resetVolume(fadeDuration);
        }
    }

    static setPanValue(song: string, pan: number = 0): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].setPan(pan);
        }
    }

    static setPan(song: string, reelCount: number, reelIndex: number): void {
        if (PlayList.Songs[song] != null) {
            let pan: number = 0;
            switch (reelCount) {
                case 3:
                    switch (reelIndex) {
                        case 0:
                            pan = -0.5;
                            break;
                        case 1:
                            pan = 0;
                            break;
                        case 2:
                            pan = 0.5;
                            break;
                        default:
                    }
                    break;
                case 4:
                    switch (reelIndex) {
                        case 0:
                            pan = -0.6;
                            break;
                        case 1:
                            pan = -0.3;
                            break;
                        case 2:
                            pan = 0.3;
                            break;
                        case 3:
                            pan = 0.6;
                            break;
                        default:
                    }
                    break;
                case 5:
                    switch (reelIndex) {
                        case 0:
                            pan = -0.7;
                            break;
                        case 1:
                            pan = -0.4;
                            break;
                        case 2:
                            pan = 0;
                            break;
                        case 3:
                            pan = 0.4;
                            break;
                        case 4:
                            pan = 0.7;
                            break;
                        default:
                    }
                    break;
                case 6:
                    switch (reelIndex) {
                        case 0:
                            pan = -0.8;
                            break;
                        case 1:
                            pan = -0.5;
                            break;
                        case 2:
                            pan = -0.2;
                            break;
                        case 3:
                            pan = 0.2;
                            break;
                        case 4:
                            pan = 0.5;
                            break;
                        case 4:
                            pan = 0.8;
                            break;
                        default:
                    }
                    break;
                default:
            }
            PlayList.Songs[song].setPan(pan);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Sounds/PlayList.ts
 **/